import { toast } from '@approvalmax/ui/src/components';
import { arrayHelpers, stringHelpers } from '@approvalmax/utils';
import uniq from 'lodash/uniq';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { useReportSchedulerContext } from '../../ReportSchedulerPopup.context';
import { messages } from './RuleEmailsSection.messages';

export const useRuleEmailsSection = (ruleIndex: number) => {
    const [text, setText] = useState('');
    const { schedule, updateRuleEmails } = useReportSchedulerContext();

    const { emails: emailsUnsorted, validationErrors } = schedule.rules[ruleIndex];
    const { emailsError } = validationErrors;

    const emails = useMemo(() => arrayHelpers.arraySort(emailsUnsorted), [emailsUnsorted]);

    const handleAdd = useCallback(() => {
        const newEmails = text.split(/[\s,;]+/).filter((x) => Boolean(x));

        const valid: string[] = [];
        const invalid: string[] = [];

        newEmails.forEach((text) => {
            const email = stringHelpers.parseEmail(text);

            if (email) {
                valid.push(email);
            } else {
                invalid.push(text);
            }
        });

        if (valid.length > 0) {
            updateRuleEmails(ruleIndex, uniq(emails.concat(valid)));
        }

        if (invalid.length > 0) {
            const textEmails = invalid.slice(0, 5).join('\n');
            const textMore = invalid.length > 5 ? messages.invalidEmailsToastMore({ count: invalid.length - 5 }) : '';

            toast.error(`${messages.invalidEmailsToast} \n ${textEmails} \n ${textMore}`);
        }

        setText(invalid.join(','));
    }, [emails, ruleIndex, text, updateRuleEmails]);

    const handleRemove = useCallback(
        (email: string) => {
            const newEmails = emails.filter((e) => e !== email);

            updateRuleEmails(ruleIndex, newEmails);
        },
        [emails, ruleIndex, updateRuleEmails]
    );

    useEffect(() => {
        if (emailsError) {
            toast.error(emailsError);
        }
    }, [emailsError]);

    return {
        text,
        setText,
        emails,
        handleAdd,
        handleRemove,
    };
};
